import React from 'react'
import { change as changeFieldValue, formValueSelector, Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from 'react-select';
import axios from 'axios';
import $ from 'jquery';
import cadastrarUsuario from '../../../actions/usuario/cadastrarUsuario'
import { buscarUsuarios } from '../../../actions/usuario/buscarUsuarios';
import alterarUsuario from '../../../actions/usuario/alterarUsuario'
import selecionarPerfis from '../../../actions/perfil/selecionarPerfis';
import limparPerfis from '../../../actions/perfil/limparPerfis';
import {
    renderFieldCheck,
    renderFieldCnpj,
    renderFieldCpf,
    renderFieldEmail,
    renderFieldNumerosPorcentagem,
    renderFieldTelefone,
    required,
    tamanhoPorcentagem,
    validarCNPJ
} from '../../../util/inputs';
import { URL } from '../../../util/ambienteActions';
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil';
import buscarUsuarioPorEmail from '../../../actions/usuario/buscarUsuarioPorEmail';
import { validaPerfis } from '../../../security/Autorizacao';
import { PERFIL_ADMIN } from '../../../security/securityContext';
import { showSuccessMsg } from '../../../util/messagesUtil';
import UsuarioLink from './UsuarioLink';
import adicionarPerfilUsuario from '../../../actions/usuario/adicionarPerfilUsuario';
import removerPerfilUsuario from '../../../actions/usuario/removerPerfilUsuario';

const OPCAO_DESCONTO_MEIA_PASSAGEM = [
    {
        label: 'Aplicar desconto no valor da Empresa',
        value: 'EMPRESA'
    },
    {
        label: 'Aplicar desconto no valor da ANTT',
        value: 'ANTT'
    },
    {
        label: 'Aplicar desconto no valor da ANTT e Empresa',
        value: 'ANTT_EMPRESA'
    }]

export const validate = (values) => {
    const errors = {};
    if (!values.nome) {
        errors.nome = 'Campo obrigatório'
    }
    if (!values.email) {
        errors.email = 'Campo obrigatório'
    }

    return errors
};

const renderField = ({
    input,
    label,
    type,
    css,
    max,
    readOnly,
    meta: { touched, error }
}) => (
    <div>
        <label className='mt-2'>{label}</label>
        <div>
            <input {...input} type={type}
                className={css}
                maxLength={max}
                style={{ borderColor: touched && error ? 'red' : '' }}
                disabled={readOnly}
                readOnly={readOnly} />
            {touched
                && (error && <span style={{ color: 'red' }}>{error}</span>)}
        </div>
    </div>
);

export class ModalAlterarUsuario extends React.Component {
    constructor(props) {
        super(props);
        this.fechar = this.fechar.bind(this);
        this.limparCampos = this.limparCampos.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.submit = this.submit.bind(this);
        this.state = {
            seNaoFoiAlteradoListaLinks: true
        }

    }

    exibirComboPerfil(event) {
        const { perfis } = this.props
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Adicionar um perfil...'
                    options={perfis}
                    isDisabled={this.naoPermiteEdicaoPerfilUsuarioSistema()}
                    onChange={(value) => {
                        event.input.onChange(value);
                        this.adicionarPerfil(value)
                    }}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                    && (event.meta.error && <span style={{ color: 'red' }}>{event.meta.error}</span>)}
            </div>
        )
    }

    adicionarPerfil(perfil) {
        const url = `${URL}/perfil/${perfil.value}/usuario/${this.props.usuarioSelecionado.id}/empresa/${this.props.usuarioSelecionado.idEmpresa}/adicionar`;
        axios.post(url, SLOW_REQUEST_CONFIG)
            .then((resp) => {
                if (resp.status === 200) {
                    const perfis = Object.assign([], this.props.perfisSelecionados);
                    const perfiJaExiste = perfis.filter(f => f.value === perfil.value);
                    if (perfiJaExiste.length === 0) {
                        perfis.push(perfil);
                        this.props.selecionarPerfis(perfis)
                        this.props.adicionarPerfilUsuario(this.props.usuarioSelecionado, perfil);
                    }
                }
            })
    }

    naoPermiteEdicaoPerfilUsuarioSistema() {
        return this.props.usuarioSelecionado?.usuarioSistema && !validaPerfis([PERFIL_ADMIN])
    }
    
    exibirAcrescimoMaximoPassagem() {
        return <div className="form-row mt-2">
            <div className="col-12 col-sm-6 col-md-6">
                <Field name='acrescimoMaximoPassagem' validate={[tamanhoPorcentagem]}
                    component={renderFieldNumerosPorcentagem}
                    css="form-control" label=" Acréscimo Máximo de Passagem(%)" />
            </div>
        </div>
    }

    exibirComissao() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');
        
        if (vendedor.length > 0) {
            let fieldComissao = '';
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                fieldComissao = <div className="col-12 col-md-2" style={{paddingTop: '22px'}}>
                    <Field name='comissaoUsuario' validate={[required, tamanhoPorcentagem]}
                            component={renderFieldNumerosPorcentagem}
                            readOnly={true}
                            css="form-control" label="Comissão(%)" />
                </div>

                this.prencheCampoComissao('10.00')
                return fieldComissao
            }
            fieldComissao = <div className="col-12 col-md-2" style={{paddingTop: '22px'}}>
                <Field name='comissaoUsuario' validate={[required, tamanhoPorcentagem]}                        
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label="Comissão(%)" />
            </div>
            return fieldComissao
        }
        this.props.changeFieldValue('formularioAlterarUsuario',
            'comissaoUsuario', '00.00');

        return ''
    }

    exibirComissaoEncomenda() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');
        
        if (vendedor.length > 0) {
            let fieldComissao = '';
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                fieldComissao = <div className="col-12 col-md-2" style={{paddingTop: '22px'}}>
                    <Field name='comissaoEncomenda' validate={[required, tamanhoPorcentagem]}
                            component={renderFieldNumerosPorcentagem}
                            readOnly={true}
                            css="form-control" label="C.Encomenda(%)" />
                </div>

                this.prencheCampoComissao('10.00')
                return fieldComissao
            }
            fieldComissao = <div className="col-12 col-md-2" style={{paddingTop: '22px'}}>
                <Field name='comissaoEncomenda' validate={[required, tamanhoPorcentagem]}                        
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label="C.Encomenda(%)" />
            </div>
            return fieldComissao
        }
        this.props.changeFieldValue('formularioAlterarUsuario',
            'comissaoEncomenda', '00.00');

        return ''
    }

    exibirComissaoExcessoBagagem() {
        const vendedor = this.props.perfisSelecionados
        .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');
    
        if (vendedor.length > 0) {
            let fieldComissao = '';
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                fieldComissao = <div className="col-12 col-md-2">
                    <Field name='comissaoExcessoBagagem' validate={[required, tamanhoPorcentagem]}
                            component={renderFieldNumerosPorcentagem}
                            readOnly={true}
                            css="form-control" label="C.Excesso Bagagem(%)" />
                </div>

                this.prencheCampoComissao('10.00')
                return fieldComissao
            }
            fieldComissao = <div className="col-12 col-md-2">
                <Field name='comissaoExcessoBagagem' validate={[required, tamanhoPorcentagem]}                        
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label="C.Excesso Bagagem(%)" />
            </div>
            return fieldComissao
        }
        this.props.changeFieldValue('formularioAlterarUsuario',
            'comissaoExcessoBagagem', '00.00');

        return ''
    }

    exibirComissaoImpressaoBilhete() {        
        const vendedor = this.props.perfisSelecionados
        .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');
    
        if (vendedor.length > 0) {
            let fieldComissao = '';
            if (this.props.empresaSelecionada.grupo === 'TCB') {
                fieldComissao = <div className="col-12 col-md-2">
                    <Field name='comissaoImpressaoBilhete' validate={[required, tamanhoPorcentagem]}
                            component={renderFieldNumerosPorcentagem}
                            readOnly={true}
                            css="form-control" label="C.Impressao Bilhete(%)" />
                </div>

                this.prencheCampoComissao('10.00')
                return fieldComissao
            }
            fieldComissao = <div className="col-12 col-md-2">
                <Field name='comissaoImpressaoBilhete' validate={[required, tamanhoPorcentagem]}                        
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label="C.Impressao Bilhete(%)" />
            </div>
            return fieldComissao
        }
        this.props.changeFieldValue('formularioAlterarUsuario',
            'comissaoImpressaoBilhete', '00.00');

        return ''

    }

    prencheCampoComissao(valor) {
        this.props.changeFieldValue('formularioAlterarUsuario', 'comissaoUsuario',
            this.props.comissaoUsuario ? this.props.comissaoUsuario : valor);
        this.props.changeFieldValue('formularioAlterarUsuario', 'comissaoEncomenda',
                this.props.comissaoEncomenda ? this.props.comissaoEncomenda : valor);
    }

    prencheCampoImpostoRetido(valor) {
        this.props.changeFieldValue('formularioAlterarUsuario', 'impostoRetido',
            this.props.usuarioSelecionado.impostoRetido ? this.props.usuarioSelecionado.impostoRetido : valor);
    }

    exibirImpostoRetido() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');
        if (vendedor.length > 0) {
            let fieldImpostoRetido = '';
            if (this.props.empresaSelecionada.grupo === 'TCB' || this.props.empresaSelecionada.grupo === 'BUSER' || this.props.empresaSelecionada.grupo === 'CIDAO') {
                if (this.props.empresaSelecionada.id == 808) {
                    return <div className="form-group">
                        <label>Imposto retido(%)</label>
                        <input type="text" className="form-control col-md-2" readOnly={true} value='0.00' name='impostoRetido' />
                    </div>
                }
                fieldImpostoRetido = <div className="form-row ">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name='impostoRetido' validate={[required, tamanhoPorcentagem]}
                            component={renderFieldNumerosPorcentagem}
                            readOnly={true}
                            css="form-control" label="imposto retido(%)" />
                    </div>
                </div>

                this.prencheCampoImpostoRetido('16.25')
                return fieldImpostoRetido
            }
            fieldImpostoRetido = <div className="form-row ">
                <div className="col-12 col-sm-6 col-md-6">
                    <Field name='impostoRetido' validate={[required, tamanhoPorcentagem]}
                        component={renderFieldNumerosPorcentagem}
                        css="form-control" label="imposto retido(%)" />
                </div>
            </div>
            return fieldImpostoRetido
        }
        this.props.changeFieldValue('formularioAlterarUsuario',
            'impostoRetido', '00.00');

        return ''
    }

    montarParametroUsuario(values) {
        const comissoes = [{ tipoServico: 'RESERVA', porcentagem: values.comissaoUsuario }, { tipoServico: 'ENCOMENDA', porcentagem: values.comissaoEncomenda },
            { tipoServico: 'EXCESSO_BAGAGEM', porcentagem: values.comissaoExcessoBagagem },  { tipoServico: 'IMPRESSAO_BILHETE', porcentagem: values.comissaoImpressaoBilhete }
        ];


        return {
            id: this.props.usuarioSelecionado.id,
            nome: values.nome,
            email: values.email,
            comissoes: comissoes,            
            impostoRetido: values.impostoRetido,
            telefone: values.telefoneUsuario,
            cpf: values.cpf,
            tipoDescontoMeiaPassagem: values.opcaoDescontoMeiaPassagem ? values.opcaoDescontoMeiaPassagem.value : 'EMPRESA',
            venderCte: values.venderCte,
            venderValorANTT: values.venderValorANTT,
            vendeGratuidade: values.vendeGratuidade,
            vendaTEF: values.vendaTEF,
            cnpjTef: values.numeroCnpjTef,
            storeIdTef: values.storeIdTef,
            links: this.props.linksSelecionados,
            acrescimoMaximoPassagem: values.acrescimoMaximoPassagem,            
            habilitadoBloqueioEdicaoPassageiro: values.habilitadoBloqueioEdicaoPassageiro,
            habilitadoBloqueioReimpressaoCupom: values.habilitadoBloqueioReimpressaoCupom,
            habilitadoComissionamentoReimpresaoPassagem: values.habilitadoComissionamentoReimpresaoPassagem,
            habilitadoAutenticacaoDoisFatores: values.habilitadoAutenticacaoDoisFatores,
            habilitadoBloqueioListaPassageiro: values.habilitadoBloqueioListaPassageiro,
            habilitadoBloqueioBuscarReservasTerceiros: values.habilitadoBloqueioBuscarReservasTerceiros            
        };
    }

    submit(values) {
        this.props.alterarUsuario(this.montarParametroUsuario(values), this.props.usuarioSelecionado.idEmpresa)
            .then(() => {
                showSuccessMsg('Usuario alterado com sucesso');
                this.limparFormulario();
                this.props.buscarUsuario();
                this.fecharModal();
            })
    }

    fecharModal() {
        $('#modalAlterarUsuario')
            .modal('hide');
        $('#modalAlterarUsuario')
            .hide();
        $('.modalAlterarUsuario')
            .hide();
    }

    limparFormulario() {
        this.props.reset('formularioAlterarUsuario');
        this.setState({ perfisSelecionados: [] });
        this.props.limparPerfis();
        this.props.limparLinks();
        this.verificaSeNaoFoiAlteradoLinks(true);
    }

    limparCampos() {
        this.props.changeFieldValue('formularioAlterarUsuario',
            'nome', '');
        this.props.changeFieldValue('formularioAlterarUsuario',
            'nomeUsuario', '');
        this.props.changeFieldValue('formularioAlterarUsuario',
            'email', '');
        this.props.changeFieldValue('formularioAlterarUsuario',
            'comissao', '');
        this.props.changeFieldValue('formularioAlterarUsuario',
            'impostoRetido', '');
        this.props.changeFieldValue('formularioAlterarUsuario',
            'agencia', '');
        this.setState({ usuario: null });
        this.props.limparPerfis();
    }

    removerPerfil(perfil) {
        const url = `${URL}/perfil/${perfil.value}/usuario/${this.props.usuarioSelecionado.id}/empresa/${this.props.empresaSelecionada.id}/remover`;
        axios.get(url, SLOW_REQUEST_CONFIG)
            .then((resp) => {
                if (resp.status === 200) {
                    const perfis = Object.assign([], this.props.perfisSelecionados);
                    const novaLista = perfis.filter(f => f.value !== perfil.value);
                    this.props.selecionarPerfis(novaLista)
                    this.props.removerPerfilUsuario(this.props.usuarioSelecionado, perfil);
                }
            })
    }

    removerAgencia() {
        this.props.changeFieldValue('formularioAlterarUsuario',
            'agencia', '');
    }

    exibirComboOpcaoDescontoMeiaPassagem(event) {
        return (
            <div>
                <Select
                    {...event.input}
                    noOptionsMessage={() => ('Nenhuma opção encontrada')}
                    placeholder='Adicionar uma opção de desconto'
                    options={OPCAO_DESCONTO_MEIA_PASSAGEM}
                    onChange={(value) => {
                        event.input.onChange(value);
                    }}
                    onBlur={() => event.input.onBlur()}
                />
                {event.meta.touched
                    && (event.meta.error && <span style={{ color: 'red' }}>{event.meta.error}</span>)}
            </div>
        )
    }

    exibirPerfisSelecionados() {
        const ehAdmin = validaPerfis([PERFIL_ADMIN])

        if (this.props.perfisSelecionados) {
            return this.props.perfisSelecionados.map(perfil => <div key={perfil.value} className="geral mb-1">
                {((perfil.value === 'ROLE_FINANCEIRO_EMPRESA' || perfil.value === 'ROLE_GESTOR_EMPRESA') && !ehAdmin) ?
                    '' :
                    <div className="resumo">
                        <div className="row">
                            <div className="col-lg-5 col-xl-5">
                                {perfil.label}
                            </div>
                            <div className="col-lg-5 col-xl-5">
                                {!this.naoPermiteEdicaoPerfilUsuarioSistema() ?
                                    <i className="material-icons nav-icon fa-1x" key={perfil.label}
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => this.removerPerfil(perfil)}>&#xe872;
                                    </i>
                                    : ''}
                            </div>
                        </div>
                    </div>
                }
            </div>)
        }
        return ''
    }

    exibirOpcaoDescontoMeiaPassagemo() {
        const vendedor = this.props.perfisSelecionados
            .filter(f => f.value === 'ROLE_VENDEDOR_AGENCIA' || f.value === 'ROLE_VENDEDOR_EMPRESA' || f.value === 'ROLE_OPERADOR_REMARCACAO' || f.value === 'ROLE_ADMIN_EMPRESA');
        if (vendedor.length > 0) {
            return (
                <div className="form-row mt-2">
                    <div className="col-12 col-sm-9 col-md-6">
                        <label>Opções de desconto de meia passagem </label>
                        <Field name='opcaoDescontoMeiaPassagem' required={true}
                            component={this.exibirComboOpcaoDescontoMeiaPassagem.bind(this)} />
                    </div>
                </div>
            )
        }
        return ''
    }

    verificaSeNaoFoiAlteradoLinks(valor) {
        this.setState({ seNaoFoiAlteradoListaLinks: valor });
    }

    fechar() {
        this.props.limparPerfis();
        this.limparFormulario();
    }

    render() {
        const {
            handleSubmit, submitting, invalid, pristine
        } = this.props;
        const usuarioSelecionado = this.props.usuarioSelecionado;
        const empresaSelecionada = this.props.empresaSelecionada;
        const naoPermiteAlterarDados = usuarioSelecionado && empresaSelecionada &&
            usuarioSelecionado.idEmpresaCadastradora !== empresaSelecionada.id && !validaPerfis([PERFIL_ADMIN]);
        const permiteMudarFlagValorANTT = !validaPerfis([PERFIL_ADMIN])

        return (
            <div className="modal fade show" id='modalAlterarUsuario' role='dialog'
                aria-labelledby='modalAlterarUsuario' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-lg'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Editar Usuário</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={() => this.fechar()}>
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            {naoPermiteAlterarDados ? <div className="mt-2 alert alert-warning" role="alert">
                                Usuário cadastrado por outra empresa.
                            </div> : ''}
                            <form onSubmit={handleSubmit(this.submit)}>
                                <div className="form-row">
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <Field name="email" type="email" component={renderFieldEmail} label="E-mail:"
                                            css="form-control" readOnly={naoPermiteAlterarDados} />
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-6">
                                        <Field name="cpf" type="text" component={renderFieldCpf} label="CPF:"
                                            css="form-control" readOnly={naoPermiteAlterarDados} />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="col-12 col-sm-8 col-md-8">
                                        <Field name="nome" type="text" required={true} component={renderField}
                                            label="Nome Completo:"
                                            readOnly={naoPermiteAlterarDados}
                                            css="form-control" />
                                    </div>
                                    <div className="col-12 col-sm-4 col-md-4">
                                        <Field name="telefoneUsuario" type="text" required={true}
                                            component={renderFieldTelefone}
                                            readOnly={naoPermiteAlterarDados}
                                            css="form-control" label="Telefone" />
                                    </div>
                                </div>

                                <div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-6">
                                            <label>Perfil usuário</label>
                                            <Field name='perfil'
                                                required={true}
                                                component={this.exibirComboPerfil.bind(this)}
                                                css="form-control col-md-12"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-6">
                                            <div className="lista-table-media">
                                                {this.exibirPerfisSelecionados()}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='venderCte' type="checkbox" component={renderFieldCheck}
                                                readOnly={false}
                                                label="Vender com cte"
                                                css="form-check-input" />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='venderValorANTT' type="checkbox" component={renderFieldCheck}
                                                readOnly={permiteMudarFlagValorANTT}
                                                label="Vender com valor antt"
                                                css="form-check-input" />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='vendeGratuidade' type="checkbox" component={renderFieldCheck}
                                                label="Vender Gratuidade"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>                                    
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoBloqueioEdicaoPassageiro' type="checkbox" component={renderFieldCheck}
                                                label="Bloquear Edição de Passagens"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoBloqueioReimpressaoCupom' type="checkbox" component={renderFieldCheck}
                                                label="Bloquear Impressão de Passagens"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoBloqueioListaPassageiro' type="checkbox" component={renderFieldCheck}
                                                    label="Bloquear lista de passageiro"
                                                    css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoBloqueioBuscarReservasTerceiros' type="checkbox" component={renderFieldCheck}
                                                label="Bloquear Cancelar/Remarcar/Em Aberto Reservas de Terceiros"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoAutenticacaoDoisFatores' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Autenticação Com 2 Fatores"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='vendaTEF' type="checkbox" component={renderFieldCheck}
                                                label="Vender TEF"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    {this.props.vendaTEF ? <><div className="form-row mb-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name="numeroCnpjTef" css='form-control' validate={[required, validarCNPJ]}
                                                component={renderFieldCnpj} label="Número CNPJ"/>
                                        </div>
                                    </div>
                                    <div className="form-row mb-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name="storeIdTef" type="text"
                                                component={renderField}                                
                                                label="Store ID TEF"
                                                css="form-control col-md-4"
                                                validate={[required]}
                                            />
                                        </div>
                                    </div></>: ''}
                                    <div className="form-row mt-2">
                                        <div className="col-12 col-sm-9 col-md-9">
                                            <Field name='habilitadoComissionamentoReimpresaoPassagem' type="checkbox" component={renderFieldCheck}
                                                label="Habilitar Comissão Passagens Reimpressas de Terceiros"
                                                css="form-check-input" readOnly={false} />
                                        </div>
                                    </div>
                                    {this.exibirAcrescimoMaximoPassagem()}
                                    <div className="form-row">
                                        {this.exibirComissao()}
                                        {this.exibirComissaoEncomenda()}
                                        {this.exibirComissaoExcessoBagagem()}
                                        {this.exibirComissaoImpressaoBilhete()}
                                    </div>
                                    {this.exibirImpostoRetido()}
                                    {this.exibirOpcaoDescontoMeiaPassagemo()}
                                </div>
                                <div className="form-row">
                                    <UsuarioLink
                                        linksSelecionados={this.props.linksSelecionados}
                                        alterarValoresLinksSelecionados={this.props.alterarValoresLinksSelecionados}
                                        verificaSeNaoFoiAlteradoLinks={this.verificaSeNaoFoiAlteradoLinks.bind(this)}
                                        classCss={'campoUrlModalAlterarUsuario'}
                                        ehUsuarioAgencia={false}
                                    />
                                </div>

                                <div className="form-group area-codigo">
                                    <Field name="idUsuario" type="hidden" component={renderField}
                                        css="form-control col-md-12" />
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" disabled={(invalid || submitting || pristine) && this.state.seNaoFoiAlteradoListaLinks
                                        && this.naoPermiteEdicaoPerfilUsuarioSistema()}
                                        className="btn btn-laranja">Salvar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        perfisSelecionados: state.perfisSelecionados,
        empresaSelecionada: state.empresaSelecionada,
        paginaAtual: state.paginaAtualUsuario,
        registrosPorPagina: state.registrosPorPaginaUsuario,
        usuarioSelecionado: state.usuarioSelecionado,
        comissaoUsuario: formValueSelector('formularioAlterarUsuario')(state, 'comissaoUsuario'),
        vendaTEF: formValueSelector('formularioAlterarUsuario')(state, 'vendaTEF'),
        numeroCnpjTef: formValueSelector('formularioAlterarUsuario')(state, 'numeroCnpjTef'),
        storeIdTef: formValueSelector('formularioAlterarUsuario')(state, 'storeIdTef'),
        initialValues: {
            email: state.usuarioSelecionado ? state.usuarioSelecionado.email : '',
            nome: state.usuarioSelecionado ? state.usuarioSelecionado.nome : '',
            cpf: state.usuarioSelecionado ? state.usuarioSelecionado.cpfCnpj : '',
            telefoneUsuario: state.usuarioSelecionado ? state.usuarioSelecionado.telefone : '',
            agencia: state.usuarioSelecionado && state.usuarioSelecionado.codigoAgencia ? {
                label: state.usuarioSelecionado.nomeAgencia,
                value: state.usuarioSelecionado.codigoAgencia
            } : null,
            opcaoDescontoMeiaPassagem: {
                label: state.usuarioSelecionado ? state.usuarioSelecionado.descTipoDescontoMeiaPassagem : '',
                value: state.usuarioSelecionado ? state.usuarioSelecionado.valorTipoDescontoMeiaPassagem : ''
            },             
            comissaoUsuario: state.usuarioSelecionado
                && state.usuarioSelecionado.comissoes
                && state.usuarioSelecionado.comissoes.length 
                && state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'RESERVA')
                ? state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'RESERVA').porcentagem : '00.00',
            comissaoEncomenda:  state.usuarioSelecionado
                && state.usuarioSelecionado.comissoes
                && state.usuarioSelecionado.comissoes.length 
                && state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'ENCOMENDA')
                ? state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'ENCOMENDA').porcentagem : '00.00',            
            comissaoExcessoBagagem: state.usuarioSelecionado
                && state.usuarioSelecionado.comissoes
                && state.usuarioSelecionado.comissoes.length 
                && state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'EXCESSO_BAGAGEM')
                ? state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'EXCESSO_BAGAGEM').porcentagem : '00.00',
            comissaoImpressaoBilhete: state.usuarioSelecionado
                && state.usuarioSelecionado.comissoes
                && state.usuarioSelecionado.comissoes.length
                && state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'IMPRESSAO_BILHETE')
                ? state.usuarioSelecionado.comissoes.find(it => it.tipoServico == 'IMPRESSAO_BILHETE').porcentagem : '00.00',
            impostoRetido: state.usuarioSelecionado ? (state.usuarioSelecionado.impostoRetido ? state.usuarioSelecionado.impostoRetido : '00.00') : '00.00',
            venderCte: state.usuarioSelecionado ? state.usuarioSelecionado.venderCte : '',
            venderValorANTT: state.usuarioSelecionado ? state.usuarioSelecionado.venderValorANTT : '',
            vendeGratuidade: state.usuarioSelecionado ? state.usuarioSelecionado.vendeGratuidade : '',            
            habilitadoComissionamentoReimpresaoPassagem: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoComissionamentoReimpresaoPassagem : '',            
            vendaTEF: state.usuarioSelecionado ? state.usuarioSelecionado.vendaTEF : '',
            numeroCnpjTef: state.usuarioSelecionado ? state.usuarioSelecionado.cnpjTef : '',
            storeIdTef: state.usuarioSelecionado ? state.usuarioSelecionado.storeIdTef : '',
            usuarioSistema: state.usuarioSelecionado ? state.usuarioSelecionado.usuarioSistema : '',
            acrescimoMaximoPassagem: state.usuarioSelecionado ? state.usuarioSelecionado.acrescimoMaximoPassagem : '0',            
            habilitadoBloqueioEdicaoPassageiro: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoBloqueioEdicaoPassageiro : '',
            habilitadoBloqueioReimpressaoCupom: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoBloqueioReimpressaoCupom : '',
            habilitadoAutenticacaoDoisFatores: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoAutenticacaoDoisFatores : '',
            habilitadoBloqueioListaPassageiro: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoBloqueioListaPassageiro : '',
            habilitadoBloqueioBuscarReservasTerceiros: state.usuarioSelecionado ? state.usuarioSelecionado.habilitadoBloqueioBuscarReservasTerceiros : '',
        }
    }
}


export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        cadastrarUsuario,
        buscarUsuarios,
        selecionarPerfis,
        buscarUsuarioPorEmail,
        alterarUsuario,
        limparPerfis,
        adicionarPerfilUsuario,
        removerPerfilUsuario
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioAlterarUsuario',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(ModalAlterarUsuario));
